import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

import App from "./App";
import store from "./redux/store";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      const waitingServiceWorker = registration.waiting;
      if (waitingServiceWorker) {
        waitingServiceWorker.addEventListener("statechange", (event) => {
          if (event.target.state === "installed") {
            // Standard way to notify user about updates
            if (
              window.confirm(
                "New content is available! Click OK to refresh and update.",
              )
            ) {
              waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
              window.location.reload();
            }
          }
        });
      }
    },
  });
} else {
  // Prevent a previously installed production worker from serving stale
  // bundles while the site is being developed on localhost.
  serviceWorkerRegistration.unregister();
}


if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (event) => {
    // Ignore generic cross-origin script errors and chrome extension errors
    if (
      event.message === 'Script error.' ||
      (event.filename && event.filename.startsWith('chrome-extension://'))
    ) {
      event.stopImmediatePropagation();
    }
  });
}
